import { FeaturedListingV3 } from 'types/featuredListingV3';
import useSWR from 'swr';
import {
  ExperienceVersion,
  GetListingsV3FeaturedPublicEndpoint,
  LanguageCode,
} from '@kouto/types';
import getFeaturedListingsV3 from 'api/listing/useFeaturedListingsV3/getFeaturedListingsV3';

type useFeaturedListingsProps = {
  skip?: boolean;
  language?: LanguageCode;
  version?: ExperienceVersion;
  isUnlisted?: boolean;
};

const useFeaturedListingsV3 = ({
  skip,
  language,
  version,
  isUnlisted,
}: useFeaturedListingsProps) => {
  const url = skip
    ? null
    : GetListingsV3FeaturedPublicEndpoint.url({
        query: {
          language,
          version,
          isUnlisted,
        },
      });

  const swr = useSWR<FeaturedListingV3[]>(
    url ? [url] : null,
    ([url]) => getFeaturedListingsV3(url),
    {
      onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
        if (retryCount >= 3) return;
        if (error.status < 500) return;
        setTimeout(() => revalidate({ retryCount }), 2 ** retryCount * 1000);
      },
    },
  );

  return swr;
};

export default useFeaturedListingsV3;
